import React from 'react'
import Main from './Main'

const VerifyAccount = () => {
  return <Main />
}

export default VerifyAccount
